import { LoadersTypes } from './loaders.action';

const INITIAL_STATE = {
  list: [],
  isFetching: false,
  error: false,
  errors: [],

  page: [],
  paging: {
    error: false,
    errors: [],
    fetching: false,
    offset: 0,
    page: 1,
    limit: 30,
    totalItems: 0,
    maxPage: 0,
  },

  filters: [],
  filtersLoading: false,
};

const onFetching = (state) => ({ ...state, isFetching: true, errors: [] });

const onError = (state, action) => {
  const { errors } = action.payload;
  return {
    ...state,
    error: true,
    errors,
    isFetching: false,
  };
};

const onGetReceive = (state, action) => {
  const { page } = action.payload;

  return {
    ...state,
    list: page,
    isFetching: false,
    error: false,
    errors: [],
  };
};

const onPageError = (state, action) => {
  const { errors } = action.payload;
  const { paging } = state;
  return {
    ...state,
    paging: {
      ...paging,
      error: true,
      errors,
    },
  };
};

const onPageFetch = (state) => {
  const { paging } = state;

  return {
    ...state,
    paging: {
      ...paging,
      fetching: true,
      error: false,
      errors: [],
    },
  };
};

const onPageReceive = (state, action) => {
  const oldPaging = state.paging;
  const { page, paging } = action.payload;

  return {
    ...state,
    page,
    paging: {
      ...oldPaging,
      fetching: false,
      error: false,
      errors: [],
      ...paging,
    },
  };
};

const onLoaderReceive = (state, action) => {
  const { loaders } = action.payload;
  const { list } = state;

  const newList = [].concat(list, loaders);

  return { ...state, list: newList };
};

const loadersReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LoadersTypes.FETCH: return onFetching(state);
    case LoadersTypes.ERROR: return onError(state, action);
    case LoadersTypes.GET_RECEIVE: return onGetReceive(state, action);
    case LoadersTypes.PAGE_ERROR: return onPageError(state, action);
    case LoadersTypes.PAGE_FETCH: return onPageFetch(state, action);
    case LoadersTypes.PAGE_RECEIVE: return onPageReceive(state, action);
    case LoadersTypes.LOADER_RECEIVE: return onLoaderReceive(state, action);
    default: return state;
  }
};

export default loadersReducers;
